import React from 'react';
import { Link } from 'react-router-dom';
import styles from './TopicCard.module.css';

interface TopicCardProps {
  title: string;
  description: string;
  link: string;
  icon?: string; // Icon is optional
}

const TopicCard: React.FC<TopicCardProps> = ({ title, description, link, icon }) => {
  return (
    <Link to={link} className={styles.cardLink}>
      <div className={styles.card}>
        {icon && <div className={styles.icon}>{icon}</div>}
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    </Link>
  );
};

export default TopicCard;